<template>
  <div class="event-item" v-if="isPublic && noEmptyCells">
    <p>
      <strong
        >{{ localeDate }} | {{ localeTime }} | {{ trim(hostname) }}</strong
      >
      <br />
      <em>{{location}}</em>
      <br />
      <a v-if="hasLink" :href="infoLink">{{trim(titleEvent) }}</a>
      <span v-else>{{ trim(titleEvent) }}</span>
      <br />
      <event-text
        :infoText="infoText"
        :presentationType="presentationType"
        :remoteType="remoteType"
        :titleEvent="titleEvent"
        :titleSession="titleSession"
        :titleTalk="titleTalk"
        :invitee1="invitee1"
        :awAwch1="invitee1AWAWCH"
        :invitee2="invitee2"
        :awAwch2="invitee2AWAWCH"
      ></event-text>

      <span class="lang-label" v-show="isForeign"> [{{ langLabel }}]</span>
    </p>
  </div>
</template>


<script>
import EventText from "./EventText.vue";
import countries from "@/assets/countries.json";

export default {
  components: {
    EventText,
  },
  props: [
    "publish",
    "access",
    "date",
    "time",
    "countryID",
    "city",
    "hostname",
    "remoteType",
    "titleEvent",
    "titleSession",
    "titleTalk",
    "invitee1",
    "invitee2",
    "invitee1AWAWCH",
    "invitee2AWAWCH",
    "presentationType",
    "infoLink",
    "regiLink",
    "infoText",
    "hasRecording",
    "recLink",
    "langLabel",
  ],
  data() {
    return {
      options: { month: "short", day: "numeric", year: "2-digit" },
      countries: countries,
    };
  },
  computed: {
    localeDate() {
      return this.date.toLocaleDateString(this.$language, this.options);
    },
    localeTime() {
      if (this.$language == "de") {
        return this.time.slice(0, 5) + " MEZ";
      } else {
        return this.time.slice(0, 5) + " CET";
      }
    },
    countryLocale(){
      if (this.$language == "de") {
        return countries[this.countryID].name_de
      }
      if (this.$language == "en") {
        return countries[this.countryID].name_en
      }
      if (this.$language == "fr") {
        return countries[this.countryID].name_fr
      }
      if (this.$language == "it") {
        return countries[this.countryID].name_it
      } else return ""
    },
    cityLocale(){
      if (this.$language == "de") {
        return this.city.name_de
      }
      if (this.$language == "en") {
        return this.city.name_en
      }
      if (this.$language == "fr") {
        return this.city.name_fr
      }
      if (this.$language == "it") {
        return this.city.name_it
      } else return ""
    },
    online(){
      if (this.$language == "fr") {
        return "en ligne"
      }
      else return "online"
    },
    hybrid(){
      if (this.$language == "de") {
        return "online"
      }
      if (this.$language == "en") {
        return "online"
      }
      if (this.$language == "fr") {
        return "hybride"
      }
      if (this.$language == "it") {
        return "ibrido"
      } else return ""
    },
    location(){
      if (this.remoteType == "online") {
        return this.online
      }
      if (this.remoteType == "hybrid") {
        return this.hybrid + " - " + this.cityLocale + ", " + this.countryLocale 
      }
      if (this.remoteType == "offline") {
        return this.cityLocale + ", " + this.countryLocale 
      } else return ""
    },
    isForeign() {
      return this.langLabel != this.$language;
    },
    isPublic() {
      return this.publish == "Published" && this.access == "Public";
    },
    noEmptyCells() {
      if (this.date == "Invalid Date") {
        console.log("No Date defined");
        return false;
      }
      if (this.time == "") {
        console.log("No Time defined");
        return false;
      }
      if (this.hostname == "") {
        console.log("No Hostname defined");
        return false;
      }
      if (this.titleEvent == "") {
        console.log("No titleEvent defined");
        return false;
      }
      if (this.langLabel == "") {
        console.log("No Language defined");
        return false;}
      else return true;
    },
    hasLink() {
      return this.infoLink !== undefined
    },
  },
  methods: {
    trim(str) {
      if (str != undefined) {
        return str.trim();
      }
    },
  },
};
</script>

<style scoped>
h3 {
  margin: 40px 0 0 !important;
}
ul {
  list-style-type: none !important;
  padding: 0 !important;
}
li {
  display: inline-block !important;
  margin: 0 10px !important;
}
a {
  color: #428bfa !important;
  text-decoration: none !important;
}
a:hover {
  text-decoration: underline !important;
}
.lang-label {
  font-family: "Courier New";
}
</style>